module.exports = __webpack_public_path__ + "static/media/2_en.2b3a01c8.png";